import CountDown from '@/public/views/count-down/count-down.view.vue';
import PublicLayout from '@/public/public.layout.vue';
import ParticipantInscription from '@/public/views/participants/participantInscription.view.vue';
import RouteNames from '@/constants/route-names';
import EditBillModal from '@/manager/billing/views/edit-bill-modal/index.vue';
import EditBudgetModal from '@/manager/budget/views/edit-budget-modal/index.vue';

const PublicRouter = {
  path: '/public/',
  component: PublicLayout,
  name: 'public',
  children: [{
    path: 'convocation/:id/participant/inscription/',
    name: 'participantInscription',
    props: true,
    component: ParticipantInscription,
  },
  {
    path: 'billing/:id',
    name: RouteNames.BillEdit,
    props: true,
    component: EditBillModal,
  },
  {
    path: 'budget/modify/:id',
    name: RouteNames.BudgetEdit,
    props: true,
    component: EditBudgetModal,
  }],
};
const CountDownRouter = {
  path: '/convocation/:id/count-down',
  name: 'countDown',
  component: CountDown,
};

export default [
  PublicRouter,
  CountDownRouter,
];
